import BasicAuthInput from './BasicAuthInput';

export default BasicAuthInput;